import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Typography } from '@mui/material'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import type { LinkExternalDto } from '@hcr/api/optimizely'
import { DividerWithLabel, ICONS, LinkUnstyled } from '@hcr/ui'

import { Path } from '../../../../../models'
import { createLinkExternal, to } from '../../../../../utils'
import { Link } from '../components'

interface UsefulLinksProps {
  links: LinkExternalDto[]
}

export const UsefulLinks: FC<UsefulLinksProps> = ({ links }) => {
  const { t } = useTranslation()

  return (
    <Box>
      <DividerWithLabel>{t('account.useful-links')}</DividerWithLabel>
      {links.map(createLinkExternal).map(link => (
        <Link component={LinkUnstyled} to={link.to} key={link.label} target='_blank' rel='external'>
          <Typography variant='labelM'>{link.label}</Typography>
          <FontAwesomeIcon aria-hidden={true} icon={ICONS.farArrowUpRightFromSquare} />
        </Link>
      ))}
      <Link component={LinkUnstyled} to={to(Path.About)}>
        <Typography variant='labelM'>{t('account.about-the-app')}</Typography>
        <FontAwesomeIcon aria-hidden={true} icon={ICONS.farChevronRight} />
      </Link>
    </Box>
  )
}
